var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-header-wrapper", class: _vm.style() },
    [
      _vm.options.showHeader
        ? _c("div", { staticClass: "modal-header" }, [
            _c(
              "div",
              { staticClass: "modal-header-left-item modal-item" },
              [
                _vm.options.showBackButton
                  ? _c("BaseBackButton", {
                      attrs: {
                        title: _vm.options.backTitle,
                        click: _vm.closeModal,
                        showIcon: _vm.options.showBackButtonIcon,
                        ariaLabel: "close modal dialog"
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal-header-title modal-item",
                attrs: {
                  tabindex: "0",
                  role: "title",
                  "aria-label": "dialog title: " + _vm.options.title
                }
              },
              [
                _vm.options.component
                  ? _c(_vm.options.component, { tag: "component" })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.options.title) }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-header-right-item modal-item" },
              [
                _vm.options.showCloseButton
                  ? _c("BaseIcon", {
                      staticClass: "modal-close-button",
                      attrs: {
                        icon: "close",
                        isCustom: true,
                        type: "standard",
                        ariaLabel: "close modal dialog"
                      },
                      on: { click: _vm.closeModal }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bbc8aa6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bbc8aa6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global-modal/ContentModalHeader.vue
// module id = null
// module chunks = 